/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ model: NonNullable<unknown> }} Audit_Details_Private_Model_Deleted_DescInputs */



/**
* | output |
* | --- |
* | "The self-hosted model \"{model}\" was removed and withdrawn from every organisation and team selection." |
*
* @param {Audit_Details_Private_Model_Deleted_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_private_model_deleted_desc = /** @type {((inputs: Audit_Details_Private_Model_Deleted_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Private_Model_Deleted_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Das selbst gehostete Modell "${i?.model}" wurde entfernt und aus allen Organisations- und Team-Auswahlen gestrichen.`)
	return /** @type {LocalizedString} */ (`The self-hosted model "${i?.model}" was removed and withdrawn from every organisation and team selection.`)
});